import React, { useEffect, useState } from 'react'
import logo from './assets/logo.png'
import hamburger from './assets/hamburger.svg'
import closeIcon from '../Nav/assets/close.svg'
import { useNavigate } from 'react-router-dom'
import ProfileDropdown from './ProfileDropdown'

const DashboardNav = () => {
  const navigate = useNavigate()
  const [navValue, setNavValue] = useState(0)
  const [isOpen, setIsOpen] = useState(false);

  const changePage = (pageNumber) => {
    switch (pageNumber) {
      case 0:
        setNavValue(pageNumber)
        window.location.href = "/dashboard"; // Forces reload and navigation
        break;
      case 1:
        setNavValue(pageNumber)
        navigate('/rate')
        break
      case 2:
        setNavValue(pageNumber)
        navigate('/submit')
        break
      case 3:
        setNavValue(pageNumber)
        navigate('/blog')
        break
      case 4:
        setNavValue(pageNumber)
        navigate('/about')
        break
      default:
        window.location.href = "/dashboard"; // Forces reload and navigation
        break;
    }
  }
  useEffect(() => {
    const url = window.location.pathname
    if (url === "/rate") {
      setNavValue(1)
    }
    else if (url === "/submit") {
      setNavValue(2)
    }
    else if (url === "/blog") {
      setNavValue(3)
    }
    else if (url === "/about") {
      setNavValue(4)
    }
  }, [setNavValue])


  const hideModal = (event) => {
    const modal = document.getElementById('modal');
    // Check if the clicked element is outside of the modal
    if (event.target !== modal && !modal.contains(event.target)) {
      // setIsClosing(true);
      // setTimeout(() => {
      //   setIsOpen(false); // Call the function to close the modal
      // }, 300); // Duration of the zoom-out animation
      setIsOpen(false);
    }
  }

  useEffect(() => {

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // Smooth scrolling behavior
      });
    };

    scrollToTop()

  }, [])
  return (
    <div className=' bg-white w-full h-[96px] md:h-[117px] lg:h-[12vh] lg:h-[14vh] fixed flex items-center justify-between px-6 md:px-8 mg:px-[64px] z-[90]'>

      <img onClick={() => changePage(0)} src={logo} alt="logo" className=' bg-white cursor-pointer w-[157px] lg:w-[266px] lg:h-[52px]' />
      <div className=' flex items-center text-center lg:gap-[25px] md:gap-[20px] text-[16px] font-black leading-[21.6px] mg:text-[18px] mg:leading-[24.6px]'>
        <button onClick={() => changePage(1)} className={`  ${navValue === 1 ? ` hidden md:flex text-ravblue cursor-not-allowed` : `${navValue > 1 ? "hidden md:flex" : "hidden md:flex"} text-[#000000] hover:opacity-70`} `}>Rate Vendor</button>
        <button onClick={() => changePage(2)} className={` ${navValue === 2 ? " hidden md:flex text-ravblue cursor-not-allowed" : "hidden md:flex text-[#000000] hover:opacity-70"} `}>List Vendor</button>
        <button onClick={() => changePage(4)} className={` ${navValue === 4 ? "hidden md:flex text-ravblue cursor-not-allowed" : "flex text-[#000000] border md:border-none border-black px-3 py-1 md:px-0 md:py-0 rounded-[80px] text-base md:text-sm lg:text-lg hover:opacity-70"} `}>About us</button>
        <button onClick={() => changePage(3)} className={` ${navValue === 3 ? "hidden md:flex text-ravblue cursor-not-allowed" : "hidden md:flex text-[#000000] hover:opacity-70"} `}>Blog</button>

        <div className='hidden md:flex'>  <ProfileDropdown changePage={changePage} navValue={navValue} /></div>
        <img src={hamburger} alt="hamburger" onClick={() => setIsOpen(true)} className=' cursor-pointer flex ml-4 md:hidden ' />

      </div>
      {isOpen && (
        <div onClick={hideModal} className={`md:hidden fixed inset-0 bg-black bg-opacity-50 z-[120] flex items-center justify-center`}>
          {/* <div onClick={hideModal} data-aos="zoom-in" data-aos-duration="3000" className={`sm:hidden fixed inset-0 bg-black bg-opacity-50 z-[120] flex items-center justify-center`}> */}

          {/* <div data-aos="fade-right" data-aos-duration="3000" data-aos-easing="ease-in-sine" id='modal' className="bg-white w-4/5 h-full max-w-[13rem] xm:max-w-[14rem] absolute left-0 transform z-50"> */}
          <div id='modal' className="bg-white w-full h-full  md:max-w-[14rem] absolute left-0 transform z-50">
            <div className='w-full flex items-center justify-between pt-[25px] px-[24px]'>
              <img onClick={() => changePage(0)} src={logo} alt="logo" className=' bg-white cursor-pointer w-[164px] h-[34px]' />
              {/* Close Button */}
              <button
                className=" text-white"
                onClick={() => setIsOpen(false)}
              >
                <img src={closeIcon} alt='close' className='  ' />
              </button>
            </div>
            {/* Your navigation links here */}
            <div className=' px-[24px] items-start justify-start mt-[52px] text-[24px] leading-[32.4px] font-black flex flex-col gap-[18px] '>
              {/* <div className='sm:hidden flex w-full'>   */}
              {/* <ProfileDropdown changePage={changePage} navValue={navValue}  isOpenDropDown={isOpenDropDown} setIsOpenDropDown={setIsOpenDropDown} /></div> */}
              {/* <div className='md:hidden flex border border-ravgray h-[80px] rounded-[80px] w-full px-[11px] items-center mb-[44px]'> */}
              <ProfileDropdown changePage={changePage} navValue={navValue} />
              {/* </div> */}

              <button onClick={() => changePage(1)} className={`  ${navValue === 1 ? ` md:hidden flex text-ravblue cursor-not-allowed  mt-[44px]` : `${navValue > 1 ? "md:hidden flex" : "md:hidden flex"} text-ravdeepblue hover:opacity-70 mt-[44px]`} `}>Rate A  Vendor</button>
              <button onClick={() => changePage(2)} className={` ${navValue === 2 ? " md:hidden flex text-ravblue cursor-not-allowed" : "md:hidden flex  text-ravdeepblue hover:opacity-70"} `}>List Vendor</button>
              <button onClick={() => changePage(3)} className={` ${navValue === 3 ? "md:hidden flex text-ravblue cursor-not-allowed" : "md:hidden flex  text-ravdeepblue hover:opacity-70"} `}>Blog</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DashboardNav

